import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectsSimpleTableIndicator } from '../../../redux/actions/indicatorProjects';
import styles from './ProjectExtendedNotFullyDisbursed.module.scss';
import { Table } from './Table/Table';
import { handleLoading } from '../../utils';
import FilterIndicators from '../../../models/FilterIndicators';
import { AppMenuTabs } from '../../MenuTabs/userTabsInterface';
import { setIndicatorResponse, setLoading } from '../../../redux/actions/dataTable';
import { getNewFilteredIndicators } from '../../../api/indicatorApi';
import { translateMultipleText } from '../../../services/stringUtil';
import { emptyProjects } from '../../Portfolio/PortfolioUtil';
import { useTranslation } from 'react-i18next';
import { ProjectProductTypes } from '../../../models/ProjectProductTypes';
import { processIndicators } from '../../Portfolio/indicatorHelper';
import { arrayMove } from 'react-sortable-hoc';
import { addIndicators } from '../../../redux/actions/indicators';
import { setCurrentIndicator } from '../../../redux/actions/currentIndicator';
import { updateCreatingOrEditing } from '../../../redux/actions/menuTabs';
import { resetIndicatorDetailFilter } from '../../../redux/actions/indicatorDetailFilters';
import { ProjectsListSkeleton } from '../../LoadersSkeletons/ProjectsListSkeleton/ProjectsListSkeleton';
import FiltersErrorMessage from '../../Util/Errors/FiltersErrorMessage/FiltersErrorMessage';

export const ProjectExtendedNotFullyDisbursed = () => {
  const [loadingData, setLoadingData] = useState(false);
  const { currentIndicator } = useSelector<any, any>(state => state);
  const { projectTypeFilterOnDetail } = useSelector<any, any>(state => state.indicatorDetailFilter);
  const dispatch = useDispatch();
  const { container, bodyContainer, emptyRowContent } = styles;
  const { t } = useTranslation();

  // Filter
  const filterIndicators = useSelector<any, FilterIndicators>(state => state.filterIndicators);
  const stateProjectProductTypes = useSelector<any, FilterIndicators>(
    state => state.indicatorPayload.payload.projectProductTypes,
  );
  const menuTabs = useSelector<any, AppMenuTabs>(state => state.menuTabs);
  const portfolioSelectedTab = menuTabs.portfolioSelectedTab;
  const creatingOrEditing = menuTabs.creatingOrEditing;
  const [isLoading, setIsLoading] = React.useState(false);
  const [totalProjects, setTotalProjects] = React.useState(false);
  const [flag, setFlag] = useState<boolean>(false);
  const [hasError, setHasError] = useState(false);

  const projectTypeFilterChange = {
    ...filterIndicators,
    common: { ...filterIndicators.common, projectTypeFilters: stateProjectProductTypes },
    projectTypeFilters: stateProjectProductTypes,
  };

  const handleCommonFilterChange = async () => {
    dispatch(setLoading(true));
    setIsLoading(true);
    setHasError(false);

    try {
      const indicatorsToProcess = await getNewFilteredIndicators(
        {},
        { projectProductTypes: stateProjectProductTypes },
        {
          ...projectTypeFilterChange.common,
        },
      );
      dispatch(setIndicatorResponse(indicatorsToProcess));
      startProcessIndicators(
        indicatorsToProcess,
        translateMultipleText(` ${' '} ${portfolioSelectedTab.title}`, t),
        filterIndicators.common.projectTypeFilters,
      );
      setTotalProjects(emptyProjects(indicatorsToProcess.totalProjects));
    } catch (err) {
      setHasError(true);
      console.error(err, 'Error fetching data from indicators');
    } finally {
      dispatch(setLoading(false));
      setIsLoading(false);
    }
  };

  const startProcessIndicators = (inds, titleFromTab, projectTypeFilter = [ProjectProductTypes.Loan]) => {
    const result = processIndicators(inds, {
      titleFromTab,
      projectTypeFilter,
    });
    const elementSummary: any = result.find(elem => elem.id === 15);
    const indexSummary: number = result.indexOf(elementSummary);
    const sendEndSummary = arrayMove(result, indexSummary, result.length);

    dispatch(addIndicators(sendEndSummary));
    dispatch(
      setCurrentIndicator(sendEndSummary?.find(data => data.indicatorKey === 'PROJECTS_EXTENDED_NOT_FULLY_DISBURSED')),
    );
    setIsLoading(false);
  };

  // const tabId0OrCreatingEditing = (menuTabs, creatingOrEditing) =>
  //   menuTabs.portfolioSelectedTab.tabId === 0 || creatingOrEditing;

  useEffect(() => {
    handleLoading(
      () =>
        getFilteredSimpleIndicators(
          dispatch,
          currentIndicator.id,
          currentIndicator.indicatorKey,
          // projectTypeFilterChange,
        ),
      setLoadingData,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIndicator.id, dispatch, projectTypeFilterOnDetail, filterIndicators.common]);

  useEffect(() => {
    if (
      filterIndicators.common.coReponsibleDivisions.length > 0 ||
      filterIndicators.common.countryId.length > 0 ||
      filterIndicators.common.divisionId.length > 0 ||
      filterIndicators.common.interestIssues.length > 0 ||
      filterIndicators.common.participantDivisions.length > 0 ||
      filterIndicators.common.regionId.length > 0 ||
      filterIndicators.common.sectors.length > 0 ||
      filterIndicators.common.teamLeaders.length > 0
    )
      handleCommonFilterChange();
    setFlag(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  useEffect(() => {
    dispatch(resetIndicatorDetailFilter());
    if (
      !menuTabs.firstLoad &&
      // tabId0OrCreatingEditing(menuTabs, creatingOrEditing) &&
      filterIndicators.common.coReponsibleDivisions.length === 0 &&
      filterIndicators.common.countryId.length === 0 &&
      filterIndicators.common.divisionId.length === 0 &&
      filterIndicators.common.interestIssues.length === 0 &&
      filterIndicators.common.participantDivisions.length === 0 &&
      filterIndicators.common.regionId.length === 0 &&
      filterIndicators.common.sectors.length === 0 &&
      filterIndicators.common.teamLeaders.length === 0 &&
      flag
    ) {
      handleCommonFilterChange();
      setFlag(false);

      if (creatingOrEditing) {
        dispatch(updateCreatingOrEditing(false));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  return (
    <>
      {!isLoading ? (
        <div className={container}>
          <div className={bodyContainer}>
            {hasError ? (
              <div className={emptyRowContent}>
                <FiltersErrorMessage isTable={true} />
              </div>
            ) : (
              <Table loading={loadingData} />
            )}
          </div>
        </div>
      ) : (
        <ProjectsListSkeleton />
      )}
    </>
  );
};

const getFilteredSimpleIndicators = (d, currentIndicatorId, currentIndicatorKey, projectTypeFilterChange?) => {
  return d(getProjectsSimpleTableIndicator(currentIndicatorId, currentIndicatorKey, projectTypeFilterChange));
};
